
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Camada_1","data-name":"Camada 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.75 52.21"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M437.57 295.67a10.84 10.84 0 10-6.73 18.45l9.86-9.85a10.84 10.84 0 00-3.13-8.6z","transform":"translate(-391.85 -271.8)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M450 320.69l-9.35-9.35a13.42 13.42 0 002.55-9.6l-2.52 2.53a10.8 10.8 0 01-9.86 9.85l-2.52 2.53a13.44 13.44 0 009.6-2.55l9.35 9.35a1.95 1.95 0 002.75-2.76z","transform":"translate(-391.85 -271.8)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M415.76 282a1.29 1.29 0 01-1.83 0 8.37 8.37 0 00-14.29 6 1.3 1.3 0 01-2.6 0 11 11 0 0118.72-7.76 1.3 1.3 0 010 1.84zm29.81-5.51a16.22 16.22 0 00-22.87 0l-.79.79a1.21 1.21 0 01-1.69 0l-.79-.79a16.17 16.17 0 00-22.87 22.87l23.66 23.66a1.22 1.22 0 001.7 0l6.39-6.4a13.45 13.45 0 01-3-.72l-.42-.17-.55-.23-.4-.19-.53-.28-.33-.18-.78-.5-.26-.19-.59-.45-.24-.2c-.26-.23-.52-.46-.76-.7a13.43 13.43 0 1119-19c.25.25.48.5.7.76l.2.25c.16.19.31.38.45.58l.19.26c.18.26.35.52.5.79a3.3 3.3 0 01.18.32l.29.53c.06.14.13.27.19.4s.15.37.23.55l.16.42a13.47 13.47 0 01.73 3l2.35-2.35a16.22 16.22 0 000-22.87z","transform":"translate(-391.85 -271.8)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M435.55 300.58h-3.7v-3.71a1.07 1.07 0 00-1.07-1.07h-2.17a1.07 1.07 0 00-1.07 1.07v3.7h-3.7a1.07 1.07 0 00-1.07 1.07v2.16a1.07 1.07 0 001.07 1.07h3.7v3.71a1.07 1.07 0 001.07 1.07h2.17a1.07 1.07 0 001.07-1.07v-3.71h3.7a1.07 1.07 0 001.07-1.07v-2.16a1.07 1.07 0 00-1.08-1.07z","transform":"translate(-391.85 -271.8)"}})])
          )
        }
      }
    